import * as microsoftTeams from '@microsoft/teams-js';
import { promiseCallback, promiseFailure } from "../types";

export function teamsPopup(
    url: string,
    resolve: promiseCallback,
    reject: promiseFailure) {
    microsoftTeams.authentication.authenticate({
        url: url,
        width: 397,
        height: 590,
        successCallback: (result) => resolve({ token: result || '' }),
        failureCallback: (reason) => reject(reason || 'Failed to authenticate with Teams')
    });
}
